import { Box } from '@mui/material';
import { ReactNode, useEffect, useState } from 'react';

interface FadeInShellProps {
	children: ReactNode;
}

const FadeInShell = ({ children }: FadeInShellProps) => {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		setVisible(true);
	}, []);

	return (
		<Box sx={{ opacity: visible ? 1 : 0, transition: 'opacity 150ms ease' }}>
			{children}
		</Box>
	);
};

export default FadeInShell;
